import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'react-bootstrap';
import PersonalCalendarList from './PersonalCalendarList';
import ExternalCalendarEventsLibrary from '../components/ExternalCalendarEventsLibrary';

const PersonalCalendars = ({ handleClose = () => {}, currUser }) => {
    const [key, setKey] = useState('calendars');
    const teamOptions = (currUser?.teamList || [])
        .map((teamEntry) => {
            const team = teamEntry?.team || {};
            const value = team?.id || team?._id;
            if (!value) return null;
            return { value, label: team?.name || 'Unnamed Team' };
        })
        .filter(Boolean);

    return (
        <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 mt-3">
            <Tab eventKey="calendars" title="Calendars">
                {key === 'calendars' && <PersonalCalendarList teamOptions={teamOptions} handleClose={handleClose} />}
            </Tab>
            <Tab eventKey="events" title="Personal Events Library">
                {key === 'events' && <ExternalCalendarEventsLibrary teamOptions={teamOptions} />}
            </Tab>
        </Tabs>
    );
};

const mapStateToProps = (state) => ({
    currUser: state.user.user,
});
export default connect(mapStateToProps)(PersonalCalendars);
